import React from "react";
import { Paper, Typography, Box } from "@mui/material";

export default function MetricCard({ title, value, subtitle }) {
    return (
        <Paper
            elevation={0}
            sx={{
                background: "var(--border)",
                borderRadius: 1,
                padding: 2.5,
                marginTop: 2,
                marginBottom: 2,
                minHeight: 120,
                display: "flex",
                width: 220,
                flexDirection: "column",
                justifyContent: "center",
                boxShadow: "0 1px 0 rgba(15, 23, 42, 0.03)",
            }}
        >
            <Typography
                sx={{
                    fontSize: 13,
                    fontWeight: 700,
                    color: "var(--cise-text-muted)",
                }}
            >
                {title}
            </Typography>

            <Typography
                sx={{
                    fontSize: 34,
                    fontWeight: 900,
                    color: "var(--cise-blue)",
                    lineHeight: 1.2,
                    mt: 0.5,
                }}
            >
                {value}
            </Typography>

            {subtitle && (
                <Typography
                    sx={{
                        fontSize: 13,
                        color: "var(--cise-text-muted)",
                        mt: 0.5,
                    }}
                >
                    {subtitle}
                </Typography>
            )}
        </Paper>
    );
}